import { InputField, Spinner } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { Container, ErrorField } from './ChangePassword.styles';
import React from 'react';
import { useChangePassword } from './ChangePassword.hooks';

export const ChangePassword = ({ onClose }: any) => {
	const {
		isCurrentPasswordError,
		isRegexError,
		errorMessage,
		hasError,
		isConfirmPasswordError,
		userPasswords,
		isLoading,
		setConfirmPassword,
		setUserPasswords,
		handleSubmit,
	} = useChangePassword(onClose);

	return (
		<Container error={hasError}>
			<h3>Elige tu nueva contraseña</h3>
			{hasError && <ErrorField>{errorMessage}</ErrorField>}
			<InputField
				id="currentPassword"
				className="password"
				label="Contraseña actual"
				placeholder="Escribe la contraseña actual"
				type="password"
				onChange={(value) =>
					setUserPasswords({ ...userPasswords, oldPassword: value })
				}
				error={isCurrentPasswordError || hasError}
				errorText={errorMessage}
			/>
			<InputField
				id="newPassword"
				className="password"
				label="Nueva contraseña"
				placeholder="Elige una nueva contraseña"
				type="password"
				error={hasError}
				errorText={errorMessage}
				onChange={(value) =>
					setUserPasswords({ ...userPasswords, newPassword: value })
				}
			/>
			<InputField
				id="confirmPassword"
				className="password"
				label="Confirmar contraseña"
				placeholder="Confirma la nueva contraseña"
				type="password"
				onChange={(value) => {
					setConfirmPassword(value);
				}}
				error={isConfirmPasswordError || isRegexError || hasError}
				errorText={errorMessage}
			/>
			<Button id="submit" onClick={handleSubmit} disabled={isLoading}>
				{isLoading ? <Spinner size="24px" color="#fff" /> : 'Continuar'}
			</Button>
		</Container>
	);
};
